<template>
    <div class="banner">
        <div class="mm" :style="{ backgroundImage: 'url(' + getImagePath(imgName) + ')' }"></div>
        <div class="banner-img">
            <img :src="getImagePath(imgName)" />
        </div>
        <div class="banner-title">
            <!--      <p>{{title}}</p>-->
        </div>
    </div>
</template>

<script>
export default {
    name: "Banner",
    props: {
        title: {
            type: String,
            default: ""
        },
        img: {
            type: String,
            default: "bgtop.jpg"
        }
    },
    computed: {
        imgName() {
            return this.img || 'bgtop.jpg';
        }
    }
};
</script>

<style lang="scss" scoped>
.banner {
    width: 100%;
    height: 300px;
    display: flex;
    position: relative;
    overflow: hidden;
    background-color: #fff;

    .mm {
        position: absolute;
        width: 100%;
        height: 100%;

        padding: 10px;
        margin: -10px;
        filter: blur(10px);

        background-position: center;
        background-size: 100%;
    }

    img {
        position: absolute;
        //width: 1240px;
        height: 100%;
        left: 50%;
        transform: translate(-50%, 0);
    }

    &-title {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 45px;
        font-weight: 400;
    }
}

@media (max-width: 768px) {
    .banner {
        height: auto;

        .mm {
            display: none;
        }

        .banner-img {
            // flex 项默认 min-width: auto 会被超宽图撑开，这里显式撑满
            width: 100%;
        }

        img {
            position: static;
            display: block;
            width: 100%;
            height: auto;
            left: auto;
            transform: none;
        }

        &-title {
            font-size: 22px;
            padding: 0 12px;
        }
    }
}
</style>
